export default __webpack_public_path__ + "static/media/staff1.f5933d6c.png";